import { render, staticRenderFns } from "./LiveText.vue?vue&type=template&id=7142f07b&scoped=true&"
import script from "./LiveText.vue?vue&type=script&lang=js&"
export * from "./LiveText.vue?vue&type=script&lang=js&"
import style0 from "./LiveText.vue?vue&type=style&index=0&id=7142f07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142f07b",
  null
  
)

export default component.exports